import { Accordion } from "react-bootstrap";

import { CustomToggle } from "../CustomToggle/CustomToggle";
import { toCustomString } from "src/common/util";
import FbaFeeModule from "./FbaFee.module.scss";

interface FbaFeeProps {
  /** 通常 FBA 配送代行手数料（税込） */
  fbaFee: number | undefined;
  /** 冷凍食品手数料（税込）。冷凍食品でなければ 0 */
  freezingFee: number | undefined;
}

export const FbaFee: React.FC<FbaFeeProps> = ({
  fbaFee,
  freezingFee,
}: FbaFeeProps) => {
  // 合計（両方が undefined なら undefined）
  const totalFee =
    fbaFee === undefined && freezingFee === undefined
      ? undefined
      : (fbaFee ?? 0) + (freezingFee ?? 0);

  return (
    /** 出荷費用（FBA手数料） **/
    <div className={`${FbaFeeModule["fba-div"]} py-2`}>
      <Accordion className="my-auto">
        <div
          className={`${FbaFeeModule["fba-div2"]} d-flex justify-content-between`}
        >
          <div className="my-auto">
            <span>出荷費用（FBA手数料）</span>
            <CustomToggle eventKey="fba-fee">詳細</CustomToggle>
          </div>
          <div className="px-2 my-auto">
            ￥ {toCustomString(totalFee)}
            <small className={`${FbaFeeModule.small} text-muted`}>
              {" "}
              (税込)
            </small>
          </div>
        </div>
        <div>
          <Accordion.Collapse eventKey="fba-fee">
            <div
              className={`${FbaFeeModule["acc-collpse"]} font-14 font-res-12 px-2 px-sm-3 py-1 py-sm-2 ms-2 ms-sm-4 my-1 my-sm-2`}
            >
              <div className="d-flex justify-content-between py-1">
                <span>FBA手数料</span>
                <span>
                  ￥ {toCustomString(fbaFee)}
                  <small className={`${FbaFeeModule.small} text-muted`}>
                    {" "}
                    (税込)
                  </small>
                </span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>冷凍食品手数料</span>
                <span>
                  ￥ {toCustomString(freezingFee)}
                  <small className={`${FbaFeeModule.small} text-muted`}>
                    {" "}
                    (税込)
                  </small>
                </span>
              </div>
            </div>
          </Accordion.Collapse>
        </div>
      </Accordion>
    </div>
  );
};
